// Career Miniapp — Lifecycle event bus
// Public API: window.careerHooks
// Customer custom JS hozzáférhet: window.careerHooks.onMount(cb), .onJobView(cb), stb.
const listeners = {
    mount: [],
    update: [],
    jobView: [],
    applySuccess: [],
};
function add(event, cb) {
    if (!listeners[event])
        listeners[event] = [];
    listeners[event].push(cb);
    return () => {
        const idx = listeners[event].indexOf(cb);
        if (idx >= 0)
            listeners[event].splice(idx, 1);
    };
}
export function emit(event, data) {
    if (!listeners[event])
        return;
    for (const cb of listeners[event]) {
        try {
            cb(data);
        }
        catch (e) {
            console.error(`careerHooks listener error on '${event}':`, e);
        }
    }
}
export function initCareerHooks() {
    if (typeof window === 'undefined')
        return;
    window.careerHooks = {
        onMount: (cb) => add('mount', cb),
        onUpdate: (cb) => add('update', cb),
        onJobView: (cb) => add('jobView', cb),
        onApplySuccess: (cb) => add('applySuccess', cb),
    };
}
